import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const sharedData: Pick<LocDef, 'feature' | 'type' | 'portal' | 'htmlAllowed' | 'shared'> = {
	feature: HubFeature.CandidateAccess,
	portal: 'CP',
	htmlAllowed: false,
	shared: false,
};

export type CpProfileEmailHistoryLocs =
	| 'CPProfileEmailHistoryPageTitle'
	| 'CPProfileEmailHistoryTabTitle'
	| 'CPProfileEmailHistoryPaginationLabel'
	| 'CPProfileEmailHistorySystemValue'
	| 'CPProfileEmailHistoryPaginationItemsPerPage'
	| 'CPProfileEmailHistoryPaginationFirstPage'
	| 'CPProfileEmailHistoryPaginationLastPage'
	| 'CPProfileEmailHistoryPaginationNextPage'
	| 'CPProfileEmailHistoryPaginationPreviousPage'
	| 'CPProfileEmailHistoryTypeLabel'
	| 'CPProfileEmailHistoryStateLabel'
	| 'CPProfileEmailHistoryCompletedLabel';

export const cpProfileEmailHistoryLocs: LocDefs<CpProfileEmailHistoryLocs> = {
	CPProfileEmailHistoryPageTitle: {
		...sharedData,
		defaultValue: 'Email History',
		displayType: 'Title',
		description: 'Page title for the email history section.',
		displayPath: 'Profile|Information|Email History|Page Title',
		legacyName: 'CandidateAccess/Profile.EmailHistory.Title.PageTitle',
	},
	CPProfileEmailHistoryTabTitle: {
		...sharedData,
		defaultValue: 'Email History',
		displayType: 'Title',
		description: 'Tab title for the email history section.',
		displayPath: 'Profile|Information|Email History|Tab Title',
		legacyName: 'CandidateAccess/Profile.EmailHistory.Title.TabTitle',
	},
	CPProfileEmailHistoryPaginationLabel: {
		...sharedData,
		defaultValue: 'Pagination',
		displayType: 'Label',
		description: 'Pagination label for the email history section.',
		displayPath: 'Profile|Information|Email History|Pagination Label',
		legacyName: 'CandidateAccess/Profile.EmailHistory.Content.PaginationLabel',
	},
	CPProfileEmailHistorySystemValue: {
		...sharedData,
		defaultValue: 'System',
		displayType: 'Content',
		description: 'System value for the email history section.',
		displayPath: 'Profile|Information|Email History|System Value',
		legacyName: 'CandidateAccess/Profile.EmailHistory.Content.System',
	},
	CPProfileEmailHistoryPaginationItemsPerPage: {
		...sharedData,
		defaultValue: 'Items per page:',
		displayType: 'Label',
		description: 'Items per page label for the email history section.',
		displayPath: 'Profile|Information|Email History|Items Per Page',
	},
	CPProfileEmailHistoryPaginationFirstPage: {
		...sharedData,
		defaultValue: 'First Page',
		displayType: 'Label',
		description: 'First page label for the email history section.',
		displayPath: 'Profile|Information|Email History|First Page',
		legacyName: 'CandidateAccess/Profile.EmailHistory.Button.FirstPage',
	},
	CPProfileEmailHistoryPaginationLastPage: {
		...sharedData,
		defaultValue: 'Last Page',
		displayType: 'Label',
		description: 'Last page label for the email history section.',
		displayPath: 'Profile|Information|Email History|Last Page',
		legacyName: 'CandidateAccess/Profile.EmailHistory.Button.LastPage',
	},
	CPProfileEmailHistoryPaginationNextPage: {
		...sharedData,
		defaultValue: 'Next Page',
		displayType: 'Label',
		description: 'Next page label for the email history section.',
		displayPath: 'Profile|Information|Email History|Next Page',
		legacyName: 'CandidateAccess/Profile.EmailHistory.Button.NextPage',
	},
	CPProfileEmailHistoryPaginationPreviousPage: {
		...sharedData,
		defaultValue: 'Previous Page',
		displayType: 'Label',
		description: 'Previous page label for the email history section.',
		displayPath: 'Profile|Information|Email History|Previous Page',
		legacyName: 'CandidateAccess/Profile.EmailHistory.Button.PreviousPage',
	},
	CPProfileEmailHistoryTypeLabel: {
		...sharedData,
		defaultValue: 'Type',
		displayType: 'Label',
		description: 'Type label for the email history section.',
		displayPath: 'Profile|Information|Email History|Type Label',
		legacyName: 'CandidateAccess/Profile.EmailHistory.MenuItem.Type',
	},
	CPProfileEmailHistoryStateLabel: {
		...sharedData,
		defaultValue: 'State',
		displayType: 'Label',
		description: 'State label for the email history section.',
		displayPath: 'Profile|Information|Email History|State Label',
		legacyName: 'CandidateAccess/Profile.EmailHistory.MenuItem.State',
	},
	CPProfileEmailHistoryCompletedLabel: {
		...sharedData,
		defaultValue: 'Completed',
		displayType: 'Label',
		description: 'Completed label for the email history section.',
		displayPath: 'Profile|Information|Email History|Completed Label',
		legacyName: 'CandidateAccess/System.Enum.EmailHistorySort.completed',
	},
};

export const CpProfileEmailHistoryLocs =
	MapLocKeys<CpProfileEmailHistoryLocs>(cpProfileEmailHistoryLocs);
export type CpProfileEmailHistoryLocsType = LocMap<CpProfileEmailHistoryLocs>;
